import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Spacings, breakpoints } from '@styles/index';
import Paper from '@base/Paper/Paper';
import H4 from '@base/H4/H4';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import { goBack } from '@utils/breadcrumbs';
import { getBatchByUID } from '@selectors/batches';
import { useSelectorToStore } from '@hooks/reduxHooks';

const Header = styled(Paper)`
  display: flex;
  padding: ${Spacings.SPACING_10B};
  position: fixed;
  top: 72px;
  width: 1136px;
  z-index: 2;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    top: 48px;
    position: sticky;
    padding: ${Spacings.SPACING_4B} 0;
    flex-direction: column;
    background: var(--color-base-0);
    box-shadow: none;
  }
`;

const Heading = styled(H4)`
  margin-left: ${Spacings.SPACING_3B};
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_6B} 0 0;
  }
`;

const BatchNameHeading = styled.span`
  margin-left: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
`;
const BatchScheduleHeader = ({ batchUID }) => {
  const batchData = useSelectorToStore(getBatchByUID(batchUID));
  return (
    <Header>
      <BreadCrumbs tags={[]} onBackClick={goBack} />
      <Heading>
        Schedule for
        <BatchNameHeading color="var(--color-text-secondary)">
          {batchData?.name}
        </BatchNameHeading>
      </Heading>
    </Header>
  );
};

export default BatchScheduleHeader;
BatchScheduleHeader.propTypes = {
  batchUID: PropTypes.string.isRequired
};
